import type { PlayerInput } from "@arcade-hockey/shared";
import type { MatchState, PlayerState } from "@arcade-hockey/sim";
import { fillChase } from "../geometry/chase.js";

// Loose-puck chaser. Slice 3: every bot whose team doesn't own the puck
// chases the puck's current position with a 0.5m deadband. Slice 4 will rank
// teammates by distance and have only the closest chase, with others
// covering downstream positions.
const CHASE_DEADBAND = 0.5;

export function fillChaserInput(input: PlayerInput, player: PlayerState, state: MatchState): void {
  fillChase(input, player, state.puck.pos.x, state.puck.pos.y, CHASE_DEADBAND);
}
